import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SaveButton from "@/common/customer.additional-data-fields/SaveButton";

const { Customer } = Mobi2Go;
const { getLoyaltyLinks } = Customer.ComoLoyalty;

const Como = ({ baseClass, closeModal }) => {
    const [links, setLinks] = useState({});
    const [t] = useTranslation('loyalty');

    useEffect(() => {
        getLoyaltyLinks().then(result => {
            setLinks(result);
        })
    }, [])

    const onOptIn = () => {

    }

    if (links === {}) return null;

    return (
        <>
            <div
                className={'m2g-text--small'}
            >
                {t('opt_in_agree')}
                <a
                    href={links.termsOfUseUrl}
                    target={"_blank"}
                    className={baseClass('-password-prompt__link')}
                >
                    {t('terms_of_use')}
                </a>
                {", "}
                <a
                    href={links.privacyPolicyUrl}
                    target={"_blank"}
                    className={baseClass('-password-prompt__link')}
                >
                    {t('privacy_policy')}
                </a>
                {t('and')}
                <a
                    href={links.loyaltyTermsUrl}
                    target={"_blank"}
                    className={baseClass('-password-prompt__link')}
                >
                    {t('loyalty_terms_of_use')}
                </a>
            </div>
            <SaveButton
                handleSave={onOptIn}
                text={t('opt_in_button')}
                baseClass={baseClass}
                saveButtonDisabled={false}
            />
        </>
    )
}

export default Como;
